import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import svenPT from '../assets/images/svenPT.jpg';
import svenTRX from '../assets/images/svenTRX.jpg';

function AboutMe() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <SEO
        title="About Your Personal Trainer"
        description="Meet Sven, a certified personal trainer with a Sports Science background. Learn about his journey, qualifications, and approach to training and nutrition."
        path="/aboutme"
      />
      <Navbar />

      <main className="flex-grow max-w-7xl mx-auto px-6 lg:px-12 py-12 lg:py-20">

        {/* Title */}
        <h1 className="text-3xl sm:text-4xl font-extrabold text-[#162E3B] text-center mb-12 lg:mb-16">
          About Me
        </h1>

        {/* Section 1: Intro */}
        <div className="flex flex-col lg:flex-row gap-10 items-center mb-16 lg:mb-24">
          <div className="lg:w-1/2 text-left space-y-5">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              If you're reading this, that means you want to know more about me. First, I want to thank you for your interest. I will gladly share a few words with you about how I ended up here.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              I have always been a physically active person, and sport has been my passion since a very young age. It was clear for me that I had to pursue something in this field. I went from trying out multiple sports to discovering the gym and the fitness space which stuck with me to this day.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              I realized how important it is to take care of your body. Everyone has their own insecurities and I can say that fitness and physical activity in general definitely helped me feel better and gain confidence.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              When we're stuck in our routine it's difficult to come out of it. It means doing something we're not used to, which means uncertainty, which means taking a risk. But it's that step which makes someone grow and learn.
            </p>
          </div>
          
          <div className="lg:w-1/2">
            <img 
              className="w-full h-[360px] sm:h-[450px] object-cover rounded-2xl shadow-lg border border-gray-100" 
              src={svenPT} 
              alt="Trainer profile" 
            />
          </div>
        </div>

        {/* Section 2: Journey & Quote */}
        <div className="flex flex-col-reverse lg:flex-row gap-10 items-center">
          <div className="lg:w-1/3">
            <img 
              className="w-full h-[360px] sm:h-[500px] object-cover rounded-2xl shadow-lg border border-gray-100" 
              src={svenTRX} 
              alt="Trainer with TRX bands" 
            />
          </div>
          
          <div className="lg:w-2/3 text-left space-y-5">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              When I first went to a gym I had no real plan and I wasn't really consistent, nor did I watch what I ate. I probably did nothing right, except the most important thing, I took action.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Eventually I started to see the first results and more importantly I realized that everybody starts somewhere, which usually is at the bottom. Throughout the years, learning from mistakes and discovering various training methods, I gained a lot of experience and perfected what I did.
            </p>
            
            {/* Editorial Blockquote Card */}
            <div className="bg-[#162E3B]/5 border-l-4 border-[#FFD82D] p-6 rounded-r-2xl my-6">
              <p className="text-base sm:text-lg font-extrabold text-[#162E3B] italic leading-normal">
                “We are what we repeatedly do. Excellence then is not an act but a habit.”
              </p>
              <cite className="block text-right text-gray-500 font-bold mt-2 not-italic">— Aristotle</cite>
            </div>

            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              During my university years, I studied Sports Science. Classes in Anatomy, Physiology, Psychology, Motor Control, Biomechanics, Neuroscience, etc., built the foundation of what I do today. Later, I took a course in Personal Training to enrich my knowledge even further and become a certified personal trainer.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Training with people directly taught me a bunch of practical things and it also showed me that not everybody is the same and that different people need different approaches. On top of that I expanded my expertise by taking an extra course in nutrition. Such a fascinating and probably my favorite topic which goes far beyond just calculating calories and worrying how much protein you eat.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Training and nutrition complement each other perfectly so it was important to me to have a deeper understanding of both. If I learned one thing from all this, then it's that my body and my health are the most valuable things in my life.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Today I try to inspire and help others who want to adopt a healthier lifestyle and reach their fitness goals. I'll be glad to be the partner you start your new journey with.
            </p>
          </div>
        </div>

      </main>

      <Footer />
    </div>
  );
}

export default AboutMe;
